import { CQReact } from 'libs/commandQuery/commandQuery.react'
import { ResendMemberInviteCommand } from 'presentation/screens/MembersScreen/MembersScreen.domain'
import { __useResendMemberInviteCommand } from 'presentation/screens/MembersScreen/useCases/command/ResendMemberInviteKeyedComand/private/ResendMemberInviteComand'

export const useResendMemberInviteCommand: () => ResendMemberInviteCommand
  = CQReact.createKeyedHook(__useResendMemberInviteCommand)
